// extracted by mini-css-extract-plugin
export default {"tasks":"uM-z","task":"vM-z","svg":"wM-z","text":"xM-z"};